import React from "react";

export const SvgSearchFilledHeart = () => {
	return (
		<svg
			width="22"
			height="21"
			viewBox="0 0 22 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.48022 1.0005H6.39681C4.89347 1.02144 3.4631 1.7056 2.4375 2.89412C1.46028 4.0895 0.946835 5.64618 1.00436 7.24054C1.06189 8.83483 1.68576 10.3436 2.74619 11.4533L10.4061 19.7347C10.5638 19.9046 10.7773 20 11 20C11.2227 20 11.436 19.9046 11.5939 19.7347L19.2538 11.4497C20.3143 10.34 20.9381 8.83128 20.9957 7.23693C21.053 5.64278 20.5397 4.08594 19.5625 2.89052C18.5339 1.7074 17.1058 1.0257 15.6041 1.00071C14.1024 0.975752 12.6557 1.60955 11.594 2.75789C11.4365 2.92817 11.2227 3.02378 11.0001 3.02378C10.7774 3.02378 10.5637 2.92817 10.4062 2.75789C9.36789 1.62769 7.95358 0.99463 6.48022 1.0005Z"
				fill="#FA4B4B"
			/>
			<path
				d="M6.48022 1.0005H6.39681C4.89347 1.02144 3.4631 1.7056 2.4375 2.89412C1.46028 4.0895 0.946835 5.64618 1.00436 7.24054C1.06189 8.83483 1.68576 10.3436 2.74619 11.4533L10.4061 19.7347C10.5638 19.9046 10.7773 20 11 20C11.2227 20 11.436 19.9046 11.5939 19.7347L19.2538 11.4497C20.3143 10.34 20.9381 8.83128 20.9957 7.23693C21.053 5.64278 20.5397 4.08594 19.5625 2.89052C18.5339 1.7074 17.1058 1.0257 15.6041 1.00071C14.1024 0.975752 12.6557 1.60955 11.594 2.75789C11.4365 2.92817 11.2227 3.02378 11.0001 3.02378C10.7774 3.02378 10.5637 2.92817 10.4062 2.75789C9.36789 1.62769 7.95358 0.99463 6.48022 1.0005Z"
				fill="#FA4B4B"
			/>
			<path
				d="M6.48022 1.0005H6.39681C4.89347 1.02144 3.4631 1.7056 2.4375 2.89412C1.46028 4.0895 0.946835 5.64618 1.00436 7.24054C1.06189 8.83483 1.68576 10.3436 2.74619 11.4533L10.4061 19.7347C10.5638 19.9046 10.7773 20 11 20C11.2227 20 11.436 19.9046 11.5939 19.7347L19.2538 11.4497C20.3143 10.34 20.9381 8.83128 20.9957 7.23693C21.053 5.64278 20.5397 4.08594 19.5625 2.89052C18.5339 1.7074 17.1058 1.0257 15.6041 1.00071C14.1024 0.975752 12.6557 1.60955 11.594 2.75789C11.4365 2.92817 11.2227 3.02378 11.0001 3.02378C10.7774 3.02378 10.5637 2.92817 10.4062 2.75789C9.36789 1.62769 7.95358 0.99463 6.48022 1.0005Z"
				stroke="#FA4B4B"
				stroke-width="1.4"
			/>
		</svg>
	);
};
